import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Auth.css';

const Login = () => {
  const [formData, setFormData] = useState({
    email: 'demo@emudata.com.au',  // Pre-fill with demo account
    password: 'password'          // Pre-fill with demo password
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      console.log('Attempting login with:', formData);
      
      // Set a small delay to ensure state updates
      setTimeout(async () => {
        try {
          const result = await login(formData);
          console.log('Login result:', result);
          
          if (result.success) {
            console.log('Login successful, navigating to dashboard');
            navigate('/dashboard');
          } else {
            console.error('Login failed with message:', result.message);
            setError(result.message || 'Login failed. Please check your credentials.');
          }
        } catch (innerErr) {
          console.error('Inner login error:', innerErr);
          setError('An unexpected error occurred. Please try again.');
        } finally {
          setLoading(false);
        }
      }, 100);
    } catch (err) {
      console.error('Outer login error:', err);
      setError('An unexpected error occurred. Please try again.');
      setLoading(false);
    }
  };

  const handleRegisterClick = () => {
    window.location.href = '/register.html';
  }

  return (
    <div className="auth-page">
      <form className="auth-form" onSubmit={handleSubmit}>
        <h2>Login</h2>
        
        {error && <div className="auth-error">{error}</div>}
        
        <input 
          type="email" 
          name="email"
          placeholder="Email" 
          value={formData.email}
          onChange={handleChange}
          required
        />
        
        <input 
          type="password" 
          name="password"
          placeholder="Password" 
          value={formData.password}
          onChange={handleChange}
          required
        />
        
        <button type="submit" disabled={loading}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
        
        <div className="auth-link-row">
          <span>Don't have an account?</span> 
          <button 
            type="button" 
            onClick={handleRegisterClick} 
            style={{ 
              background: 'none',
              border: 'none',
              color: '#00bcd4', 
              fontWeight: 'bold', 
              marginLeft: '5px',
              cursor: 'pointer',
              padding: 0
            }}
          >
            Register
          </button>
        </div>
      </form>
    </div>
  );
};

export default Login; 